import React, { useState, useContext, useMemo, useEffect } from "react"
import {
    Box,
    FormControl,
    Select,
    MenuItem,
    ListSubheader,
    TextField,
    InputAdornment
} from "@mui/material"
import { KeyboardArrowDown, Search } from "@mui/icons-material"
import { sxSelect, sxMenuPaper } from "./ComboBoxSx"
import { LogsInitContext } from "../../Providers/LogsInitComponentesContext/LogsInitComponentesContext"

const Teste = (text, searchText) => text.toLowerCase().indexOf(searchText.toLowerCase()) > -1

export default function ComboBox({ name, options, label = "descricao", valor = "id", required, onChange, defaultValue, newSx, todos = false, separado = false, reset = false, ...rest }) {
    const { LogInit } = useContext(LogsInitContext)
    LogInit('ComboBox', 'componente')

    const [searchText, setSearchText] = useState("")
    const [selectValue, setSelectValue] = useState(defaultValue || "")

    const displayedOptions = useMemo(
        () => options.filter((option) => Teste(option[label], searchText)),
        [searchText, options, label]
    )
    useEffect(() => {
        if (reset) {
            setSearchText("")
            setSelectValue("")
        }
    }, [reset])

    const handleSelectChange = (event) => {
        setSelectValue(event.target.value)
        if (onChange) {
            onChange(event)
        }
    }

    return (
        <Box>
            {options &&
                <FormControl sx={{ width: '100%', color: 'black' }}>
                    {/* <Typography id="search-select-label">Revenda</Typography> */}
                    <Select
                        name={name}
                        sx={{ ...sxSelect, ...newSx }}
                        value={selectValue}
                        MenuProps={{
                            autoFocus: false,
                            PaperProps: { sx: sxMenuPaper },
                            sx: { '& .Mui-selected': { backgroundColor: '#9d56b93f' } }
                        }} // Disables auto focus on MenuItems and allows TextField to be in focus
                        inputProps={{
                            sx: { padding: '0 5px' }
                        }}
                        labelId="search-select-label"
                        IconComponent={KeyboardArrowDown}
                        id="navbar_revenda_select"
                        onChange={handleSelectChange}
                        onClose={() => setSearchText("")}
                        // This prevents rendering empty string in Select's value
                        // if search text would exclude currently selected option.
                        // renderValue={() => options.nome}
                        defaultValue={defaultValue || ""}
                        {...rest}
                    >
                        {/* TextField is put into ListSubheader so that it doesn't
              act as a selectable item in the menu
              i.e. we can click the TextField without triggering any selection. */}
                        <ListSubheader>
                            <TextField
                                size="small"
                                // Autofocus on textfield
                                autoFocus
                                placeholder="Pesquisar..."
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    )
                                }}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key !== "Escape") {
                                        // Prevents autoselecting item while typing (default Select behaviour)
                                        e.stopPropagation()
                                    }
                                }}
                            />
                        </ListSubheader>
                        {
                            !todos &&
                            <MenuItem key={`menu_combo_vazio`} value="">
                                Nenhuma opção
                            </MenuItem>
                        }
                        {displayedOptions.map((option, i) => (
                            <MenuItem sx={{ height: '30px', maxWidth: '480px' }} key={`menu_combo_${i}`} value={option[valor]}>
                                {/* {option[label]} */}
                                {!separado
                                    ? (<span>{option[label]}</span>)
                                    : (<><span style={{ width: "45px" }}>{option[valor]}</span><span> - {option[label]}</span></>)
                                }
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </Box>
    )
}
